export default function logIn(state = {
    payload: {
        token: null
    },
}, action) {
    if (action.type === "Login") {
        return action.payload;
    }

    return state;
}
